var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86753 0.560474L5.83706 4.71248L1.24507 5.36806C0.43288 5.49294 0.1205 6.49192 0.714023 7.08506L3.99401 10.3005L3.21306 14.8272C3.08811 15.6388 3.96278 16.2632 4.68125 15.8886L8.77343 13.7345L12.8344 15.8886C13.5528 16.2632 14.4275 15.6388 14.3026 14.8272L13.5216 10.3005L16.8016 7.08506C17.3951 6.49192 17.0827 5.49294 16.2705 5.36806L11.7098 4.71248L9.64809 0.560474C9.30447 -0.157542 8.24238 -0.18876 7.86753 0.560474Z",
    fill: "#E6A151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullstar);
export default __webpack_public_path__ + "static/media/fullstar.838f94125360b2afaedfdc9f65c50d78.svg";
export { ForwardRef as ReactComponent };